export default function hello() {
   return "Hello";
}
